import { Link } from "react-router-dom";
import { Phone, MessageCircle, Calendar } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function MobileStickyBar() {
  const primary = BUSINESS.phones[0];
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-slate-200 bg-white/95 backdrop-blur"
      data-testid="mobile-sticky-bar"
    >
      <div className="grid grid-cols-3">
        <a href={`tel:${primary.tel}`} className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-slate-700" data-testid="stickybar-call-button">
          <Phone className="h-5 w-5" style={{ color: "var(--icrack-magenta)" }} />
          <span className="text-[11px] font-semibold">Call</span>
        </a>
        <a href={BUSINESS.whatsapp.href} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-slate-700 border-l border-r border-slate-200" data-testid="stickybar-whatsapp-button">
          <MessageCircle className="h-5 w-5 text-green-600" />
          <span className="text-[11px] font-semibold">WhatsApp</span>
        </a>
        <Link to="/book" className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-white" style={{ background: "var(--icrack-magenta)" }} data-testid="stickybar-book-button">
          <Calendar className="h-5 w-5" />
          <span className="text-[11px] font-semibold">Book</span>
        </Link>
      </div>
    </div>
  );
}
